import React from "react";
import SampleCategoriesPage from "../../../features/admin/sample-categories/sample-categories-page";

export default function SampleCategories() {
  return <SampleCategoriesPage />;
}
